import { fromJS } from 'immutable';
import * as ReducerActions from './actions';

const initialState = fromJS({
  data: {
    configVidriera: null,
  },
  isLoading: false,
  error: null,
});

export default function configGlobalReducer(state = initialState, action) {
  switch (action.type) {
    case ReducerActions.FETCH_CONFIG_VIDRIERA:
      return state.set('isLoading', true).set('error', null);

    case ReducerActions.FETCH_CONFIG_VIDRIERA_SUCCESS:
      return state
        .setIn(['data', 'configVidriera'], action.payload)
        .set('isLoading', false);

    case ReducerActions.FETCH_CONFIG_VIDRIERA_FAILURE:
      return state.set('isLoading', false).set('error', action.payload);

    default:
      return state;
  }
};
